import type {
  FrontInboxInfoT,
  FrontInfo,
  IMPORT_STATE,
  ImportHistoryItemT,
} from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

type FrontWorkspaceRes = {
  alias: string;
  name: string;
  state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  inbox_infos: FrontInboxInfoT[];
  privacy_policy: boolean;
};

const frontService = {
  async createFrontInfo(
    code: string,
    workspaceAlias: string,
    redirect_uri: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/front/authenticated`,
        { code, redirect_uri },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getFrontInfo(alias: string): Promise<FrontInfo> {
    const res = await defaultAxios.get<FrontWorkspaceRes>(
      `/workspaces/${alias}/front/`,
    );
    return {
      alias: res.data.alias,
      workspace_id: alias,
      name: res.data.name,
      import_state: res.data.state,
      history: res.data.history,
      inbox_infos: res.data.inbox_infos,
      privacy_policy: res.data.privacy_policy,
    };
  },
  async importWorkspaceFeedback(
    workspaceAlias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/front/import`,
        {
          start_date: startDate,
          end_date: endDate,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async updateFrontPrivacy(privacy: boolean) {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.patch(`/workspaces/${wa}/front/privacy`, {
        privacy_policy: privacy,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteFrontInfo(alias: string) {
    try {
      const res = await defaultAxios.delete(`/front/${alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async getInboxInfos(alias: string) {
    try {
      const res = await defaultAxios.get(`/front/${alias}/inbox`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async pushInboxInfo(alias: string, info: FrontInboxInfoT) {
    try {
      const res = await defaultAxios.patch(`/front/${alias}/push`, info);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async pullInboxInfo(alias: string, info: FrontInboxInfoT) {
    try {
      const res = await defaultAxios.patch(`/front/${alias}/pull`, info);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async fetchFrontSentiments(convId: string) {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(
        `/workspaces/${wa}/front/sentences?conv_id=${convId}`,
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default frontService;
